import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import type { NumPrevHeatmapImage } from 'services/api/Meteorology';
import { cssVar } from 'constants/theme';

import FullscreenHeatmap from './FullscreenHeatmap';

import './index.scss';

export default function HeatmapDisplay({
  images,
  fetching,
  forecastDate,
}: {
  images: NumPrevHeatmapImage[];
  fetching: boolean;
  forecastDate?: string;
}) {
  const [fullscreenModelo, setFullscreenModelo] = useState<string | null>(null);

  if (fetching) {
    return (
      <div className="tf-pnt-mobile-heatmap-loading">
        <Spinner role="status" />
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <p className="tf-pnt-mobile-heatmap-empty">Não foram encontradas imagens para as variáveis selecionadas</p>
    );
  }

  const fullscreenImage = images.find(({ modelo }) => modelo === fullscreenModelo);

  return (
    <div className="tf-pnt-mobile-heatmap">
      {images.map(({ modelo, image }) => {
        const label = `${modelo.toUpperCase()}${forecastDate ? ` - ${forecastDate}` : ''}`;

        return (
          <div key={modelo} className="tf-pnt-mobile-heatmap-card">
            <div className="tf-pnt-mobile-heatmap-card-header">
              <span className="tf-pnt-mobile-heatmap-card-label">{label}</span>
              <button
                type="button"
                aria-label={`Tela cheia ${modelo.toUpperCase()}`}
                className="tf-pnt-mobile-heatmap-card-action"
                onClick={() => setFullscreenModelo(modelo)}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={cssVar('text-strong')}
                  strokeWidth={1.8}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M8 21H5a2 2 0 0 1-2-2v-3M16 21h3a2 2 0 0 0 2-2v-3" />
                </svg>
              </button>
            </div>
            <img src={`data:image/png;base64,${image}`} alt={`Heatmap ${modelo}`} />
          </div>
        );
      })}
      <FullscreenHeatmap
        open={!!fullscreenImage}
        dismiss={() => setFullscreenModelo(null)}
        base64={fullscreenImage?.image ?? ''}
        alt={fullscreenImage ? `Heatmap ${fullscreenImage.modelo}` : ''}
      />
    </div>
  );
}
